import { Load } from "./model/Load";
import { LoadType } from "./model/LoadType";

export const loadPresets: Load[] = [
  {
    type: LoadType.Europallet,
    label: "Europalette",
    width: 120,
    length: 80,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "Europalette, Übermaß",
    width: 120,
    length: 80,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "Düsseldorfer Palette",
    width: 60,
    length: 80,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "Containerpalette",
    width: 114,
    length: 114,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "Gitterbox",
    width: 84,
    length: 124,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "Rollbehälter",
    width: 71,
    length: 80,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "palettiert, eigenes Maß",
    width: 0,
    length: 0,
    height: 0,
    totalWeight: 0,
    count: 1
  },
  {
    type: LoadType.Other,
    label: "nicht palettiert, eigenes Maß",
    width: 0,
    length: 0,
    height: 0,
    totalWeight: 0,
    count: 1
  }
];
